import { render, staticRenderFns } from "./ReportCompetencyIDP.vue?vue&type=template&id=5f305633&scoped=true"
import script from "./ReportCompetencyIDP.vue?vue&type=script&lang=js"
export * from "./ReportCompetencyIDP.vue?vue&type=script&lang=js"
import style0 from "./ReportCompetencyIDP.vue?vue&type=style&index=0&id=5f305633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f305633",
  null
  
)

export default component.exports